import moment from 'moment'

import { TimeFormatsLocaleUnsafe } from '@/lib/datetime'
import { entityGenerator } from '@/lib/entityGenerator'
import { NationalId, TravelerDocumentType } from '@/types/document'

export const emptyNationalId = entityGenerator<NationalId>({
	id: null,
	type: TravelerDocumentType.National_ID,
	number: '',
	expiration_date: null,
	country: { code: '', name: '' },
})

export function prepareNationalIdJson(nationalId: NationalId) {
	const copy: Partial<NationalId> = { ...nationalId }
	delete copy.id
	copy.expiration_date = moment(copy.expiration_date!).format(TimeFormatsLocaleUnsafe.DateOnly)
	return copy
}
